/**
 * Region-specific compliance helpers for bulk wine documents (PDF + detail view).
 *
 * The wording is statutory, so it lives here as the single source of truth and is
 * shared between the API (PDF generation) and the Admin frontend (detail page).
 */

export const NZ_COMPLIANCE_STATEMENT =
  'This wine complies with New Zealand legislation, and all relevant records are available for inspection.';

export const AU_COMPLIANCE_STATEMENT =
  'This wine complies with Australian legislation, and all relevant records are available for inspection.';

/**
 * Whether the given country name refers to an Australian region.
 * Anything that isn't Australia is treated as New Zealand, since the app is
 * NZ-centric and an unknown/missing country should safely default to NZ.
 */
export const isAustralianRegion = (countryName?: string | null): boolean =>
  (countryName || '').toLowerCase().includes('australia');

/**
 * The compliance statement for the region the wine belongs to.
 */
export const getComplianceStatement = (countryName?: string | null): string =>
  isAustralianRegion(countryName) ? AU_COMPLIANCE_STATEMENT : NZ_COMPLIANCE_STATEMENT;

/**
 * The "For New Zealand Only" section should only appear for New Zealand regions.
 */
export const shouldShowNzSection = (countryName?: string | null): boolean =>
  !isAustralianRegion(countryName);
